import {useEffect, useSyncExternalStore} from 'react';
import {createRingClient} from '../services/ringClient';
import {RingOutcomeLookup} from '../services/ringOutcomeLookup';
import {ringOutcomes, type RingOutcome} from '../services/ringOutcomes';

let sharedLookup: RingOutcomeLookup | undefined;

const lookupRingOutcome = (roomId: string, notificationEventId: string): void => {
    sharedLookup ??= new RingOutcomeLookup(createRingClient());
    void sharedLookup.resolve(roomId, notificationEventId);
};

export const resetRingOutcomeLookup = (): void => {
    sharedLookup = undefined;
};

export const useRingOutcome = (
    roomId: string,
    notificationEventId: string | undefined,
    shouldLookUp: boolean,
): RingOutcome | undefined => {
    const outcome = useSyncExternalStore(
        ringOutcomes.subscribe,
        () => (notificationEventId ? ringOutcomes.peek(notificationEventId) : undefined),
    );
    useEffect(() => {
        if (shouldLookUp && notificationEventId && !outcome) {
            lookupRingOutcome(roomId, notificationEventId);
        }
    }, [roomId, notificationEventId, shouldLookUp, outcome]);
    return outcome;
};
